import styled from 'styled-components';
import { createInputDisabledCSS } from 'ui/inputs/InputStyles';
import { colors, mediumShadow, spacing, zIndex } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { SingleDateCalendar } from './calendar/SingleDateCalendar';
import { DatePickerInput } from './datePickerInput/DatePickerInput';

export const DateAndCalendarWrapper = styled.div`
  position: relative;
  display: inline-block;
  ${({ isDisabled }: { isDisabled?: boolean }) => isDisabled && createInputDisabledCSS()};
`;

export const RowWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
`;

export const DatePickerWrapper = styled.div`
  width: ${pxToRem(130)};
  appearance: none;
`;

// accounts for discrepancies with Storybook default styling
// and prevents incorrect width from being rendered there
export const StyledDatePickerInput = styled(DatePickerInput)`
  box-sizing: border-box;
`;

export const StyledSingleDateCalendar = styled(SingleDateCalendar)`
  display: inline-block;
  padding: 0 ${spacing.quarter} 0 0;
  background: ${colors.white};
  z-index: ${zIndex.newDropdown};
  border-radius: ${spacing.quarter};
  ${mediumShadow}
`;

export const PopoverTriggerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
